import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";


export const getStudyMaterialDocumentSuccess = (data) => {
  return {
    type: actionTypes.GET_STUDY_MATERIAL_DOCUMENT,
    payload: {
      studyMaterialDocument: data.Data,
    },
  };
};

export const getStudyMaterialDocument = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/GetStudyMaterialDocument`, data)
    .then((response) => {
      if (response) {
        dispatch(getStudyMaterialDocumentSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
